import React from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Col,
  Modal,
  Tab,
  Row,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { tambahKorwil, getAllKorwil, getAllClient } from "stores";
import { penempatanKorwil } from "stores";
import { editStatusKorwil } from "stores";
import { resetPassword } from "stores";

function ListKorwil() {
  const dispatch = useDispatch();
  const korwil = useSelector((state) => state.korwilReducer);
  const storeClient = useSelector((state) => state.clientReducer);
  const auth = useSelector((state) => state.authReducer);
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const [modalKorwil, setModalKorwil] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [nik, setNik] = React.useState("");
  const [role, setRole] = React.useState("");
  const [nama, setNama] = React.useState("");
  const [nopeg, setNopeg] = React.useState("");
  const [pilihClient, setPilihClient] = React.useState(null);
  const [listKorwil, setListKorwil] = React.useState([]);
  const [listClient, setListClient] = React.useState([]);
  const [idClient, setIdClient] = React.useState("");
  const [idKoordinatorWilayah, setIdKoordinatorWilayah] = React.useState("");
  const [filterClient, setFilterClient] = React.useState([]);
  const [status, setStatus] = React.useState("");
  const [searchText, setSearchText] = React.useState("");
  const [hoverBatal, setHoverBatal] = React.useState(false);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleNikChange = (e) => {
    const inputNik = e.target.value;
    const formattedNik = inputNik.slice(0, 16);
    setNik(formattedNik);
  };

  const remainingDigits = 16 - nik.length;

  const hasilFilterClient = (idClient) => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    let tmpFilter = listClient.filter((currentValue, index, arr) => {
      return currentValue.value === idClient;
    });
    tmp.push(tmpFilter[0]);
    setFilterClient(tmp);
  };

  const submitKorwil = () => {
    if (nik.length < 16) {
      Swal.fire({
        title: "NIK harus 16 digit !!",
        icon: "warning",
      });
      return;
    }

    tambahKorwil({
      nik: nik,
      nama: nama,
      nopeg: nopeg,
      idClient: idClient,
    })
      .then((response) => {
        if (response.data.status === 200) {
          const newPassword = response.data.defaultPassword;

          // STEP 1: Tutup modal form input terlebih dahulu
          handleModalClose();
          if (typeof setModalKorwil === "function") {
            setModalKorwil(false);
          }

          // STEP 2: Beri jeda 250ms (nunggu animasi modal Bootstrap selesai fade-out)
          setTimeout(() => {
            // STEP 3: Baru munculkan Swal berisi password dengan tenang
            Swal.fire({
              title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
              icon: "success",
              width: "700px",
              confirmButtonColor: "#1D3557",
              confirmButtonText: "Saya Sudah Menyalin & Selesai",
              allowOutsideClick: false,
              html: `
    <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
      <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
        Akun berhasil dibuat! Kredensial ini <span style="color: #dc2626; font-weight: 800;">HANYA MUNCUL SEKALI</span>. 
        Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
      </p>
      
      <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
        <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
        <button 
          id="btn-copy-pass"
          type="button"
          style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
        >
          Copy
        </button>
      </div>
    </div>
    <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
      <i class="fas fa-lock"></i>
      <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
    </div>
  `,
              didOpen: () => {
                const confirmBtn = Swal.getConfirmButton();
                const copyBtn = document.getElementById("btn-copy-pass");
                const warningText =
                  document.getElementById("copy-warning-text");

                // 1. Secara default, matikan (disable) tombol konfirmasi Swal
                if (confirmBtn) {
                  confirmBtn.disabled = true;
                  confirmBtn.style.opacity = "0.5"; // Membuat tampilannya agak samar/redup saat disable
                  confirmBtn.style.cursor = "not-allowed";
                }

                if (copyBtn) {
                  copyBtn.addEventListener("click", () => {
                    // 2. Proses copy text ke clipboard
                    navigator.clipboard.writeText(newPassword);

                    // 3. Ubah style tombol copy menjadi sukses
                    copyBtn.innerText = "Copied!";
                    copyBtn.style.backgroundColor = "#10B981";

                    // 4. Aktifkan kembali tombol konfirmasi Swal setelah di-copy
                    if (confirmBtn) {
                      confirmBtn.disabled = false;
                      confirmBtn.style.opacity = "1";
                      confirmBtn.style.cursor = "pointer";
                    }

                    // 5. Ubah teks peringatan di bawah menjadi hijau/aman
                    if (warningText) {
                      warningText.style.color = "#10B981";
                      warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                    }
                  });
                }
              },
            }).then((result) => {
              if (result.isConfirmed || result.isDismissed) {
                getAllKorwil(dispatch, { idClient: "" });
              }
            });
          }, 250); // Jeda transisi aman untuk modal bootstrap
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message || "Terjadi kesalahan",
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            error.response?.data?.message || "Terjadi kesalahan pada sistem.",
        });
      });
  };

  const checkStatus = () => {
    if (status.value === undefined || status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status wajib diisi !",
      });
    } else {
      submitEditStatus();
    }
  };

  const submitEditStatus = () => {
    editStatusKorwil({
      idKorwil: idKoordinatorWilayah,
      status: status.value,
    })
      .then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllKorwil(dispatch, { idClient: "" });
          setModalEdit(false);
          setStatus("");
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitPenempatan = () => {
    if (pilihClient === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Client tidak boleh kosong",
      });
    } else {
      // const selectedCities = multipleSelect.map((option) => option.value);
      penempatanKorwil({
        idKoordinatorWilayah: idKoordinatorWilayah,
        idClient: idClient,
        // selectedCities: selectedCities
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setModalPenempatan(false);
          // setIdClient("");
          // setPilihClient("");
          getAllKorwil(dispatch, { idClient: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setPilihClient(null);
    setModalKorwil(false);
    setModalPenempatan(false);
    setIdClient("");
    setPilihClient(null);
    setNik("");
    setNopeg("");
    setNama("");
  };

  // const submitResetPassword = async (data) => {
  //   try {
  //     const response = await resetPassword({
  //       idUser: data.idUser,
  //       role: data.role,
  //     });

  //     Swal.fire({
  //       title: "Sukses",
  //       text: response.data.message,
  //       icon: "success",
  //     });
  //   } catch (error) {
  //     Swal.fire({
  //       title: "Error",
  //       text: error.response.data.message,
  //       icon: "error",
  //     });
  //   }
  // };

  React.useEffect(() => {
    let tmp =
      korwil.listKorwil &&
      korwil.listKorwil.map((val) => {
        const isAktif = val.status === "aktif";

        return {
          ...val,
          action: (
            <div className="d-flex justify-content-center align-items-center">
              {/* 1. BUTTON PENEMPATAN KORWIL */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Penempatan Korwil</Tooltip>}
              >
                <Button
                  disabled={!isAktif}
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: isAktif ? "#447DF7" : "#E2E8F0",
                    border: "none",
                    color: isAktif ? "white" : "#94A3B8",
                    cursor: isAktif ? "pointer" : "not-allowed",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    hasilFilterClient(val.idClient);
                    setIdKoordinatorWilayah(val._id);
                    getAllClient(dispatch, { idClient: val.idClient });
                    setModalPenempatan(!modalPenempatan);
                  }}
                >
                  <i
                    className="fas fa-map-marked-alt"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* 2. BUTTON EDIT STATUS */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Edit Status</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: "#76CD26",
                    border: "none",
                    color: "white",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => {
                    setIdKoordinatorWilayah(val._id);
                    setModalEdit(!modalEdit);
                  }}
                >
                  <i
                    className="fas fa-user-edit"
                    style={{ fontSize: "16px" }}
                  ></i>
                </Button>
              </OverlayTrigger>

              {/* 3. BUTTON RESET PASSWORD */}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Reset Password</Tooltip>}
              >
                <Button
                  className="btn-icon mx-1 shadow-sm d-flex align-items-center justify-content-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    borderRadius: "10px",
                    backgroundColor: "#F87171",
                    border: "none",
                    color: "white",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#EF4444")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "#F87171")
                  }
                  onClick={async () => {
                    const result = await Swal.fire({
                      title: "Reset Password",
                      text: `Apakah Anda yakin ingin mereset password pengguna ${val.nama}?`,
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#1D3557",
                      cancelButtonColor: "#d33",
                      confirmButtonText: "Ya, Reset Password!",
                    });

                    if (result.isConfirmed) {
                      try {
                        // 1. Panggil API reset password
                        const response = await resetPassword({
                          idUser: val._id,
                          role: val.role,
                        });

                        // 2. Ambil password plain text dari response backend kamu
                        const newPassword = response.data.defaultPassword;

                        // 3. Tampilkan SweetAlert Sukses berukuran besar dengan tombol konfirmasi terkunci
                        Swal.fire({
                          title: "⚠️ PENTING: SIMPAN PASSWORD INI!",
                          icon: "success",
                          width: "700px", // Membuat ukuran pop-up lebih besar dan dominan
                          confirmButtonColor: "#1D3557",
                          confirmButtonText: "Saya Sudah Menyalin & Selesai",
                          allowOutsideClick: false, // Mencegah admin tidak sengaja klik luar modal
                          html: `
          <div style="text-align: left; background-color: #fffbeb; padding: 20px; border: 2px solid #fef3c7; border-radius: 12px; margin-top: 15px;">
            <p style="margin-bottom: 12px; color: #b45309; font-size: 15px; font-weight: 600; line-height: 1.5;">
              Password berhasil direset! Sistem telah men-hash password baru ini demi keamanan. 
              <br><span style="color: #dc2626; font-weight: 800;">Kredensial ini HANYA MUNCUL SEKALI</span>. 
              Silakan klik tombol <strong>Copy</strong> untuk mengaktifkan tombol selesai:
            </p>
            
            <div style="display: flex; align-items: center; justify-content: space-between; background: white; padding: 14px 20px; border: 2px solid #1D3557; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.05);">
              <code id="raw-password" style="font-size: 20px; font-weight: 800; color: #1d3557; letter-spacing: 0.5px;">${newPassword}</code>
              <button 
                id="btn-copy-pass"
                type="button"
                style="background: #1D3557; color: white; border: none; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-size: 14px; font-weight: 700; transition: all 0.2s ease; min-width: 80px;"
              >
                Copy
              </button>
            </div>
          </div>
          <div id="copy-warning-text" style="display: flex; align-items: center; justify-content: center; gap: 8px; margin-top: 15px; color: #dc2626; font-size: 13px; font-weight: 700;">
            <i class="fas fa-lock"></i>
            <span>Tombol konfirmasi terkunci! Silakan salin password terlebih dahulu.</span>
          </div>
        `,
                          didOpen: () => {
                            const confirmBtn = Swal.getConfirmButton();
                            const copyBtn =
                              document.getElementById("btn-copy-pass");
                            const warningText =
                              document.getElementById("copy-warning-text");

                            // Secara default, kunci tombol konfirmasi utama
                            if (confirmBtn) {
                              confirmBtn.disabled = true;
                              confirmBtn.style.opacity = "0.5";
                              confirmBtn.style.cursor = "not-allowed";
                            }

                            if (copyBtn) {
                              copyBtn.addEventListener("click", () => {
                                // Proses copy teks password ke clipboard
                                navigator.clipboard.writeText(newPassword);

                                // Modifikasi tombol copy menjadi sukses
                                copyBtn.innerText = "Copied!";
                                copyBtn.style.backgroundColor = "#10B981";

                                // Buka kunci tombol konfirmasi utama setelah berhasil di-copy
                                if (confirmBtn) {
                                  confirmBtn.disabled = false;
                                  confirmBtn.style.opacity = "1";
                                  confirmBtn.style.cursor = "pointer";
                                }

                                // Ubah teks peringatan di bawah box menjadi hijau/aman
                                if (warningText) {
                                  warningText.style.color = "#10B981";
                                  warningText.innerHTML = `<i class="fas fa-check-circle"></i> <span>Password berhasil disalin! Anda sekarang dapat menutup jendela ini.</span>`;
                                }
                              });
                            }
                          },
                        });
                      } catch (error) {
                        Swal.fire({
                          title: "Error",
                          text:
                            error.response?.data?.message ||
                            "Terjadi kesalahan pada sistem.",
                          icon: "error",
                        });
                      }
                    }
                  }}
                >
                  <i className="fas fa-key" style={{ fontSize: "15px" }}></i>
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
    setListKorwil(tmp);
  }, [korwil.listKorwil]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "aktif":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    header: {
      style: { minHeight: "56px" },
    },
    headRow: {
      style: {
        backgroundColor: "#F8F9FC",
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: "#E3E6F0",
      },
    },
    headCells: {
      style: {
        fontWeight: "800",
        fontSize: "13px",
        color: "#4E73DF", // Warna identitas AM
        textTransform: "uppercase",
      },
    },
    rows: {
      style: {
        minHeight: "70px", // Row lebih tinggi agar data tidak sesak
        "&:not(:last-child)": {
          borderBottomStyle: "solid",
          borderBottomWidth: "1px",
          borderBottomColor: "#E3E6F0",
        },
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#5A5C69",
      },
    },
  };

  const colKorwil = [
    {
      name: "No",
      width: "80px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Kode User",
      minWidth: "150px",
      center: true,
      selector: (row) => row.kodeUser,
    },
    {
      name: "No Karyawan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Nama",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Jabatan",
      minWidth: "200px",
      center: true,
      selector: (row) =>
        row.role === "koordinator wilayah"
          ? "Koordinator Wilayah"
          : "Koordinator Wilayah",
    },
    {
      name: "BPD",
      minWidth: "200px",
      center: true,
      // omit: true,
      selector: (row) =>
        row.penempatan.length === 0
          ? "Belum Penempatan"
          : row.penempatan[0].namaClient.namaClient,
    },
    {
      name: "Status",
      minWidth: "140px",
      center: true,
      cell: (row) => {
        const isActive = row.status === "aktif";
        return (
          <span
            style={{
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "bold",
              backgroundColor: isActive ? "#D1FAE5" : "#FEE2E2",
              color: isActive ? "#065F46" : "#991B1B",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: isActive ? "#10B981" : "#EF4444",
                marginRight: "8px",
              }}
            ></span>
            {isActive ? "Aktif" : "Tidak Aktif"}
          </span>
        );
      },
    },
    {
      name: "Aksi",
      minWidth: "250px",
      center: true,
      omit: auth.role === "super admin" || auth.role === "admin" ? false : true,
      selector: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    getAllKorwil(dispatch, { idClient: "" });
    getAllClient(dispatch);
  }, []);

  return (
    <>
      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => setModalPenempatan(false)}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            backgroundColor: "#F8F9FC",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        />
        <Modal.Body
          style={{
            backgroundColor: "#F8F9FC",
            padding: "0 40px 40px 40px",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-map-marker-alt fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3
              style={{
                fontWeight: "800",
                color: "#1e293b",
                marginBottom: "5px",
              }}
            >
              Penempatan Korwil
            </h3>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Tentukan lokasi client untuk Koordinator ini
            </p>
          </div>

          <Card
            style={{
              border: "none",
              borderRadius: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
            }}
          >
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#475569",
                    marginBottom: "10px",
                    display: "block",
                  }}
                >
                  Pilih Client
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={pilihClient}
                  onChange={(value) => {
                    setPilihClient(value);
                    setIdClient(value.value);
                  }}
                  options={filterClient}
                  placeholder="Pilih Client Penempatan"
                />
              </Form.Group>
              <Button
                className="btn-block p-3"
                style={{
                  border: "none",
                  backgroundColor: "#3b82f6",
                  boxShadow: "0 10px 20px rgba(59, 130, 246, 0.3)",
                  borderRadius: "15px",
                  fontWeight: "800",
                }}
                onClick={submitPenempatan}
              >
                SIMPAN PENEMPATAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalEdit}
        onHide={() => {
          setStatus("");
          setModalEdit(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            backgroundColor: "#F8F9FC",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        />
        <Modal.Body
          style={{
            backgroundColor: "#F8F9FC",
            padding: "0 40px 40px 40px",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          <div className="text-center mb-4">
            {/* Container Icon Center Presisi */}
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-user-shield fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3
              style={{
                fontWeight: "800",
                color: "#1e293b",
                marginBottom: "5px",
              }}
            >
              Update Status Akun
            </h3>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Aktifkan atau non-aktifkan akses pengguna ini
            </p>
          </div>

          <Card
            style={{
              border: "none",
              borderRadius: "20px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
            }}
          >
            <Card.Body className="p-4">
              <Form.Group className="mb-4">
                <label
                  style={{
                    fontWeight: "700",
                    fontSize: "14px",
                    color: "#475569",
                    marginBottom: "10px",
                    display: "block",
                  }}
                >
                  <i className="fas fa-info-circle mr-2 text-primary"></i>{" "}
                  Status Akun
                </label>
                <Select
                  classNamePrefix="react-select"
                  value={status}
                  onChange={(selectedOption) => setStatus(selectedOption)}
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Tidak Aktif" },
                  ]}
                  placeholder="Pilih Status..."
                />
              </Form.Group>
              <Button
                className="btn-block p-3"
                style={{
                  border: "none",
                  backgroundColor: "#1D3557",
                  boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                  borderRadius: "15px",
                  fontWeight: "800",
                }}
                onClick={checkStatus}
              >
                SIMPAN PERUBAHAN
              </Button>
              <Button
                variant="link"
                className="btn-block mt-2 font-weight-bold text-muted text-decoration-none"
                onClick={() => setModalEdit(false)}
              >
                BATALKAN
              </Button>
            </Card.Body>
          </Card>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalKorwil}
        onHide={() => {
          handleModalClose();
          setModalKorwil(false);
        }}
        centered
        style={{ backdropFilter: "blur(5px)" }}
      >
        <Modal.Header
          closeButton
          style={{
            border: "none",
            backgroundColor: "#F8F9FC",
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
          }}
        />
        <Modal.Body
          style={{
            backgroundColor: "#F8F9FC",
            padding: "0 40px 40px 40px",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
          }}
        >
          <div className="text-center mb-4">
            <div
              style={{
                width: "70px",
                height: "70px",
                backgroundColor: "#1D3557",
                borderRadius: "20px",
                display: "flex", // Pakai flex biasa
                alignItems: "center", // Center vertikal
                justifyContent: "center", // Center horizontal
                boxShadow: "0 10px 20px rgba(29, 53, 87, 0.2)",
                marginBottom: "15px",
                marginRight: "auto", // Gabungan auto kiri-kanan
                marginLeft: "auto", // biar container birunya di tengah modal
              }}
            >
              <i
                className="fas fa-user-tie fa-2x text-white"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%", // Paksa icon ambil ruang penuh
                  margin: 0,
                  padding: 0,
                  lineHeight: 1,
                  textAlign: "center",
                }}
              ></i>
            </div>

            <h3
              style={{
                fontWeight: "800",
                color: "#1e293b",
                marginBottom: "5px",
              }}
            >
              Tambah Koordinator Wilayah
            </h3>
            <p className="text-muted" style={{ fontSize: "15px" }}>
              Input data lengkap untuk pendaftaran Korwil baru
            </p>
          </div>

          <Form className="form">
            <Card
              style={{
                border: "none",
                borderRadius: "20px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.03)",
              }}
            >
              <Card.Body className="p-4">
                <Row>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-id-card mr-2 text-primary"></i> NIK
                      </label>
                      <div className="position-relative">
                        <Form.Control
                          className="border-0 bg-light p-3"
                          style={{
                            borderRadius: "12px",
                            fontWeight: "600",
                            paddingRight: "80px",
                          }}
                          onChange={handleNikChange}
                          value={nik}
                          type="text"
                          placeholder="Masukkan NIK"
                        />
                        <small
                          className="position-absolute"
                          style={{
                            right: "15px",
                            top: "15px",
                            color: "#94a3b8",
                            fontWeight: "bold",
                          }}
                        >
                          {remainingDigits} digit
                        </small>
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-user mr-2 text-primary"></i> Nama
                        Lengkap
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        placeholder="Nama"
                        type="text"
                        onChange={(e) => setNama(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="6" className="mb-3">
                    <Form.Group>
                      <label
                        style={{
                          fontWeight: "700",
                          fontSize: "14px",
                          color: "#475569",
                          marginBottom: "10px",
                          display: "block",
                        }}
                      >
                        <i className="fas fa-id-badge mr-2 text-primary"></i> No
                        Karyawan
                      </label>
                      <Form.Control
                        className="border-0 bg-light p-3"
                        style={{ borderRadius: "12px", fontWeight: "600" }}
                        onChange={(e) => setNopeg(e.target.value)}
                        placeholder="No Karyawan"
                        type="text"
                      />
                    </Form.Group>
                  </Col>
                  {auth.role === "super admin" && (
                    <Col md="6" className="mb-3">
                      <Form.Group>
                        <label
                          style={{
                            fontWeight: "700",
                            fontSize: "14px",
                            color: "#475569",
                            marginBottom: "10px",
                            display: "block",
                          }}
                        >
                          <i className="fas fa-building mr-2 text-primary"></i>{" "}
                          Pilih Client
                        </label>
                        <Select
                          classNamePrefix="react-select"
                          value={pilihClient}
                          onChange={(value) => {
                            setPilihClient(value);
                            setIdClient(value.value);
                          }}
                          options={listClient}
                          placeholder="Pilih Client"
                        />
                      </Form.Group>
                    </Col>
                  )}
                </Row>
                <div className="mt-4">
                  <Button
                    className="btn-block p-3"
                    style={{
                      border: "none",
                      backgroundColor: "#1D3557",
                      boxShadow: "0 10px 20px rgba(29, 53, 87, 0.3)",
                      borderRadius: "15px",
                      fontWeight: "800",
                    }}
                    onClick={submitKorwil}
                  >
                    SUBMIT DATA KORWIL
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
      </Modal>

      <Tab.Content className="mt-3">
        <Card className="border-0 bg-transparent">
          {/* Container Flex: Tombol di Kiri, Search di Kanan */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
            {/* BAGIAN KIRI: Tombol Tambah Korwil */}
            <div className="mb-3 mb-md-0">
              {(auth.role === "super admin" || auth.role === "admin") && (
                <Button
                  onClick={() => setModalKorwil(!modalKorwil)}
                  className="btn-fill d-flex align-items-center shadow-sm"
                  style={{
                    backgroundColor: "#1D3557", // Navy yang sama dengan sebelumnya
                    border: "none",
                    borderRadius: "10px",
                    padding: "10px 24px",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
                  onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
                >
                  <i
                    className="nc-icon nc-simple-add mr-2"
                    style={{ fontSize: "1.1rem" }}
                  ></i>
                  <span>Tambah Koordinator Wilayah</span>
                </Button>
              )}
            </div>

            {/* BAGIAN KANAN: Search Bar (Kontras Tinggi) */}
            <div style={{ width: "100%", maxWidth: "350px" }}>
              <InputGroup
                className="shadow-sm"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  border: "1px solid #ced4da", // Agar tidak "hilang" di background putih
                }}
              >
                <InputGroup.Text
                  className="border-0"
                  style={{ backgroundColor: "#f8f9fa" }}
                >
                  <i className="nc-icon nc-zoom-split text-dark fw-bold"></i>
                </InputGroup.Text>
                <Form.Control
                  className="border-0 ps-1"
                  type="text"
                  value={searchText}
                  onChange={handleSearch}
                  placeholder="Cari No. Karyawan / Nama..."
                  style={{
                    height: "45px",
                    backgroundColor: "#f8f9fa",
                    boxShadow: "none",
                    fontSize: "0.95rem",
                  }}
                />
              </InputGroup>
            </div>
          </div>
        </Card>
      </Tab.Content>

      {/* TABEL DENGAN CONTAINER CARD AGAR RAPI */}
      <Card
        className="border-0 shadow-sm"
        style={{ borderRadius: "12px", overflow: "hidden" }}
      >
        <DataTable
          columns={colKorwil}
          data={listKorwil.filter(
            (row) =>
              row.nama.toLowerCase().includes(searchText.toLowerCase()) ||
              row.nopeg.toLowerCase().includes(searchText.toLowerCase()),
          )}
          customStyles={customStyles}
          pagination
          paginationPerPage={itemsPerPage}
          onChangePage={handlePageChange}
          responsive
          highlightOnHover
        />
      </Card>
    </>
  );
}

export default ListKorwil;
